
import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Container, Row, Label, CardHeader, FormGroup, Input, } from "reactstrap";
import { breadcrumbReturnFunc, btnIsDissablefunc, } from "../../../components/Common/CommonFunction";
import { useDispatch, useSelector } from "react-redux";

import { MetaTags } from "react-meta-tags";
import { mode, pageId, } from "../../../routes";
import { commonPageField, commonPageFieldSuccess } from "../../../store/actions";
import { comAddPageFieldFunc, formValChange, formValid, initialFiledFunc, } from "../../../components/Common/validationFunction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import * as _cfunc from "../../../components/Common/CommonFunction";

import { SaveButton } from "../../../components/Common/CommonButton";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import { getRole } from "../../../store/Administrator/RoleMasterRedux/action";
import { resetPortalRegistrationState, savePortalRegistration } from "../../../store/Administrator/PortalRegistrationRedux/action";


const India_Portal_Registration = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();

    // ----------------------
    // Initial Field Config
    // ----------------------
    const fileds = {
        gstin_number: "",
        einvoice_userName: "",
        einvoice_password: "",
        eway_userName: "",
        eway_password: "",
        gst_userName: "",

    };

    // ----------------------
    // Local States
    // ----------------------
    const [pageMode, setPageMode] = useState(mode.defaultsave);
    const [state, setState] = useState(() => initialFiledFunc(fileds));
    const [userPageAccessState, setUserAccState] = useState("");


    // ----------------------
    // Redux State
    // ----------------------
    const {
        postMsg,
        pageField,
        userAccess,
        saveBtnloading,
    } = useSelector((state) => ({
        saveBtnloading: state.PortalRegistrationReducer.saveBtnLoading,
        postMsg: state.PortalRegistrationReducer.PostData,
        userAccess: state.Login.RoleAccessUpdateData,
        pageField: state.CommonPageFieldReducer.pageField,
    }));


    // ----------------------
    // Page Field Load
    // ----------------------
    useEffect(() => {
        const page_Id = pageId.INDIA_PORTAL_REGISTRATION;
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(page_Id));
    }, [dispatch]);

    useEffect(() => {
        dispatch(getRole());
    }, [dispatch]);

    // ----------------------
    // Derived Values
    // ----------------------
    const values = { ...state.values };
    const { isError } = state;

    const { fieldLabel } = state;
    const location = { ...history.location };


    // ----------------------
    // User Access & Breadcrumb
    // ----------------------
    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;

        userAcc = userAccess.find(
            (inx) => `/${inx.ActualPagePath}` === locationPath
        );

        if (userAcc) {
            setUserAccState(userAcc);
            breadcrumbReturnFunc({ dispatch, userAcc });
        }
    }, [userAccess]);

    // ----------------------
    // Dynamic Page Fields
    // ----------------------
    useEffect(() => {
        
        if (pageField) {
            const fieldArr = pageField.PageFieldMaster;
            comAddPageFieldFunc({ state, setState, fieldArr });
        }
    }, [pageField]);

    // ----------------------
    // SAVE Success Effect
    // ----------------------
    useEffect(() => {

        //  SUCCESS (200)
        if (postMsg?.Status === true && postMsg?.StatusCode === 200) {

            setState((prev) => ({
                ...prev,
                values: initialFiledFunc(fileds).values
            }));

            dispatch(resetPortalRegistrationState());

            customAlert({
                Type: 1,
                Status: true,
                Message: postMsg.Message,
            });
        }

        //  ERROR (400 / Status false)
        else if (postMsg?.StatusCode === 400) {

            dispatch(resetPortalRegistrationState());

            customAlert({
                Type: 1,
                Status: true,
                Message: postMsg.Message,
            });
        }

    }, [postMsg]);



    // --------------Save Handler----------------

    // const SaveHandler = async (event) => {

    //     event.preventDefault();
    //     const btnId = event.target.id;

    //     try {

    //         if (formValid(state, setState)) {


    //             btnIsDissablefunc({ btnId, state: true });

    //             const jsonBody = JSON.stringify({
    //                 gstin_number: values.gstin_number,
    //                 einvoice_userName: values.einvoice_userName,
    //                 einvoice_password: values.einvoice_password,
    //                 eway_userName: values.eway_userName,
    //                 eway_password: values.eway_password,
    //                 gst_userName: values.gst_userName,
    //             });
    //             dispatch(savePortalRegistration({ jsonBody }));

    //         }
    //     } catch (e) {
    //         btnIsDissablefunc({ btnId, state: false });
    //     }
    // };


    const SaveHandler = async (event) => {

        event.preventDefault();
        const btnId = event.target.id;
    
        try {
    
            let errors = {};
    
            //  Required validation (frontend)
            if (!values.gstin_number?.trim()) {
                errors.gstin_number = "GSTIN Number is required";
            }
    
            if (!values.einvoice_userName?.trim()) {
                errors.einvoice_userName = "Einvoice Username is required";
            }
    
            if (!values.einvoice_password?.trim()) {
                errors.einvoice_password = "Einvoice Password is required";
            }
    
            if (!values.eway_userName?.trim()) {
                errors.eway_userName = "Eway Username is required";
            }
    
            if (!values.eway_password?.trim()) {
                errors.eway_password = "Eway Password is required";
            }
    
            if (!values.gst_userName?.trim()) {
                errors.gst_userName = "GST Username is required";
            }
    
            //  If any error → show & stop
            if (Object.keys(errors).length > 0) {
                setState(prev => ({
                    ...prev,
                    isError: errors
                }));
                return;
            }
    
            // If no error → API call
            btnIsDissablefunc({ btnId, state: true });
    
            const jsonBody = JSON.stringify({
                gstin_number: values.gstin_number,
                einvoice_userName: values.einvoice_userName,
                einvoice_password: values.einvoice_password,
                eway_userName: values.eway_userName,
                eway_password: values.eway_password,
                gst_userName: values.gst_userName,
            });
    
            dispatch(savePortalRegistration({ jsonBody }));
    
        } catch (e) {
            btnIsDissablefunc({ btnId, state: false });
        }
    };



    if (!(userPageAccessState === '')) {
        return (
            <React.Fragment>
                <MetaTags>{_cfunc.metaTagLabel(userPageAccessState)}</MetaTags>
                <div className={"page-content"} >

                    <Container fluid>
                        <Row>
                            <Col lg={12}>
                                <Card className="text-black" >
                                    <CardHeader className="card-header   text-black c_card_header" >
                                        <h4 className="card-title text-black">{userPageAccessState.PageDescription}</h4>
                                        <p className="card-title-desc text-black" dangerouslySetInnerHTML={{ __html: userPageAccessState.PageDescriptionDetails }} />
                                    </CardHeader>

                                    <CardBody className="mb-3">
                                        <form noValidate>
                                            <Card >
                                                <CardBody className="c_card_body ">
                                                    <Row className="align-items-end p-2">
                                                        <Col sm="4">

                                                            <FormGroup className="m-3">
                                                                <Label>{fieldLabel.gstin_number}</Label>
                                                                <Input
                                                                    name="gstin_number"
                                                                    id="txtName"
                                                                    value={values.gstin_number}
                                                                    type="text"
                                                                    placeholder="Enter Gstin Number"
                                                                    autoComplete="off"
                                                                    onChange={(event) => formValChange({ event, state, setState })}
                                                                />
                                                              {isError?.gstin_number && (
                                                                    <small className="text-danger">{isError.gstin_number}</small>
                                                                )}

                                                            </FormGroup>


                                                            <FormGroup className="m-3">
                                                                <Label>{fieldLabel.einvoice_userName}</Label>

                                                                <Input
                                                                    name="einvoice_userName"
                                                                    id="txtName"
                                                                    value={values.einvoice_userName}
                                                                    type="text"
                                                                    placeholder="Enter Einvoice UserName"
                                                                    autoComplete="off"
                                                                    onChange={(event) => formValChange({ event, state, setState })}
                                                                />
                                                                 {isError?.einvoice_userName && (
                                                                    <small className="text-danger">{isError.einvoice_userName}</small>
                                                                )}
                                                            </FormGroup>

                                                            <FormGroup className="m-3">
                                                                <Label>{fieldLabel.eway_userName}</Label>
                                                                <Input
                                                                    name="eway_userName"
                                                                    id="txtName"
                                                                    value={values.eway_userName}
                                                                    type="text"
                                                                    placeholder="Enter Eway UserName"
                                                                    autoComplete="off"
                                                                    onChange={(event) => formValChange({ event, state, setState })}
                                                                />
                                                               {isError?.eway_userName && (
                                                                    <small className="text-danger">{isError.eway_userName}</small>
                                                                )}
                                                            </FormGroup>


                                                        </Col>
                                                        <Col sm="1"></Col>
                                                        <Col sm="4 ">


                                                            <FormGroup className="m-3">
                                                                <Label>{fieldLabel.gst_userName}</Label>
                                                                <Input
                                                                    name="gst_userName"
                                                                    id="txtName"
                                                                    value={values.gst_userName}
                                                                    type="text"
                                                                    placeholder="Enter Gst UserName"
                                                                    autoComplete="off"
                                                                    onChange={(event) => formValChange({ event, state, setState })}

                                                                />
                                                               {isError?.gst_userName && (
                                                                    <small className="text-danger">{isError.gst_userName}</small>
                                                                )}
                                                            </FormGroup>


                                                            <FormGroup className="m-3">
                                                                <Label>{fieldLabel.einvoice_password}</Label>
                                                                <Input
                                                                    name="einvoice_password"
                                                                    id="txtName"
                                                                    value={values.einvoice_password}
                                                                    type="text"
                                                                    placeholder="Enter Einvoice Password"
                                                                    autoComplete="off"
                                                                    onChange={(event) => formValChange({ event, state, setState })}
                                                                />
                                                              {isError?.einvoice_password && (
                                                                    <small className="text-danger">{isError.einvoice_password}</small>
                                                                )}
                                                            </FormGroup>



                                                            <FormGroup className="m-3">
                                                                <Label>{fieldLabel.eway_password}</Label>
                                                                <Input
                                                                    name="eway_password"
                                                                    id="txtName"
                                                                    value={values.eway_password}
                                                                    type="text"
                                                                    placeholder="Enter Eway Password"
                                                                    autoComplete="off"
                                                                    onChange={(event) => formValChange({ event, state, setState })}

                                                                />
                                                             {isError?.eway_password && (
                                                                    <small className="text-danger">{isError.eway_password}</small>
                                                                )}
                                                            </FormGroup>



                                                        </Col>
                                                    </Row>

                                                </CardBody>
                                            </Card>

                                            <FormGroup className="mt-2">
                                                <SaveButton
                                                    loading={saveBtnloading}
                                                    onClick={SaveHandler}
                                                    pageMode={pageMode}
                                                    userAcc={userPageAccessState}
                                                    module={"PORTAL_REGISTRATION"}
                                                />
                                            </FormGroup >
                                        </form>
                                    </CardBody>
                                </Card>
                            </Col >
                        </Row >
                    </Container >
                </div >
            </React.Fragment >
        );
    }
    else {
        return (
            <React.Fragment></React.Fragment>
        )
    }
}



export default India_Portal_Registration
